import { graphql, useStaticQuery } from 'gatsby';

import { SiteMetadata, SiteMetaDataGraphql } from '../../types';

export const useSiteMetadata = (): SiteMetadata => {
	const data: SiteMetaDataGraphql = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					title
					description
					siteUrl
				}
			}
		}
	`);

	return data.site.siteMetadata;
};
